<template>
	<page>
		<module>
			<waitDelivery-list></waitDelivery-list>
			<okDelivery-list></okDelivery-list>
		</module>
	</page>
</template>

<script>
	import waitDeliveryList from './purchase_order_wait_delivery_list.vue'
	import okDeliveryList from './purchase_order_ok_delivery_list.vue'
	
	export default {
		components: {
			waitDeliveryList,
			okDeliveryList
		},
		
		props: {
			tab: String
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
</style>
